const ADD_USER = (state, userId) => {
  state.users[userId] = {}
}

const SET_USER_PROP = (state, data) => {
  let user = {}
  user[data.key] = data.value
  let users = {}
  users[data.userId] = { ...state.users[data.userId], ...user }
  state.users = { ...state.users, ...users }
}

export default {
  ADD_USER,
  SET_USER_PROP
}



// WEBPACK FOOTER //
// ./src/store/modules/user/locally/mutations.js